import React from "react";
import "./ThemeSettings.css";

export default function ThemeSettings() {
  return (
    <div className="theme-settings-page">
      {/* Page Header */}
      <div className="page-header">
        <h2>App Theme Settings</h2>
        <div className="breadcrumb">
          <a href="/">Home</a> / App Settings / <span>App Basic Settings</span>
        </div>
      </div>

      {/* Section: Theme Settings */}
      <div className="card">
        <h3>Theme Settings</h3>
        <div className="form-grid">
          <div>
            <label>Show Theme Setting</label>
            <select>
              <option>Enable</option>
              <option>Disable</option>
            </select>
          </div>
          <div>
            <label>Dark Mode</label>
            <select>
              <option>Enable</option>
              <option>Disable</option>
            </select>
          </div>
          <div>
            <label>Theme Color</label>
            <select>
              <option>Warning</option>
              <option>Primary</option>
              <option>Success</option>
              <option>Danger</option>
            </select>
          </div>
        </div>

        <div className="radio-group">
          <label>Select Client Dashboard</label>
          <div className="radio-options">
            <label>
              <input type="radio" name="dashboard" />
              Show Charts in Dashboards
            </label>
            <label>
              <input type="radio" name="dashboard" defaultChecked />
              Show Simple Dashboard
            </label>
          </div>
        </div>

        <button className="btn-submit">Update</button>
      </div>

      {/* Section: App Notification Visibility Settings */}
      <div className="card">
        <h3>App Notification Visibility Settings</h3>
        <div className="form-grid">
          <div>
            <label>Select Position</label>
            <select>
              <option>Bottom Right</option>
              <option>Bottom Left</option>
              <option>Top Right</option>
              <option>Top Left</option>
            </select>
          </div>
          <div>
            <label>Show/Hide Close Button</label>
            <select>
              <option>Show</option>
              <option>Hide</option>
            </select>
          </div>
          <div>
            <label>Show/Hide Progress Bar</label>
            <select>
              <option>Show</option>
              <option>Hide</option>
            </select>
          </div>
          <div>
            <label>Timeout in Seconds or Infinite</label>
            <input type="text" placeholder="3000" />
          </div>
        </div>
        <button className="btn-submit">Update</button>
      </div>

      {/* Footer */}
      <div className="footer">
        <p>
          Copyright © 2025 <span>Ample Markets</span>. All rights reserved.
        </p>
        <p className="version">Version 2.0</p>
      </div>
    </div>
  );
}

